import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { Provider } from 'react-redux';
import store from './Apis/stores/root-store';

import { BrowserRouter } from 'react-router-dom';

import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST
};
const root = ReactDOM.createRoot(document.getElementById('root'));

const configureRootStore = store();

root.render(
  <React.StrictMode>
    <Provider store={configureRootStore}>
      <BrowserRouter>
        <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
          <App />
        </PostHogProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
